import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/common/alert.service';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { CommonService } from 'src/app/services/common.service';
import { DelegateService } from 'src/app/services/delegate.service';

@Component({
  selector: 'app-add-delegate',
  templateUrl: './add-delegate.component.html',
  styleUrls: ['./add-delegate.component.css']
})
export class AddDelegateComponent implements OnInit {
  DelegateCreationForm: FormGroup;
  delegateList: any;
  delegateID: string;
  btnValue: string;
  filterList: any;

  constructor(private _fb: FormBuilder,private status: HTTPStatus, private error: AppErrorHandler, 
    private _router: Router, public _delegateService: DelegateService, public _commonService: CommonService,
    private _activeRoute: ActivatedRoute,public _alertService: AlertService) { }

  ngOnInit() {
       /*****************************GetData By QueryString*************************/
       this.delegateID = this._activeRoute.snapshot.paramMap.get('ID');
       /**************************************End**********************************/

    this.DelegateCreationForm = this._fb.group({ 
      DelegateId:[''],       
      DelegateName: [, [Validators.required]],     
      IsActive:[, [Validators.required]],  
      EmployeeName:[''],
      EmployeeGPN:['']  
    });

    if (this.delegateID != null) {
      this.btnValue = 'Update';
      this.DelegateCreationForm.controls.DelegateId.setValue(this.delegateID);
      this.GetDelegateByID(this.delegateID);
    } else {
      this.btnValue = 'Submit';   
      this.DelegateCreationForm.controls.IsActive.setValue(String(true))  
    }
  }

  SearchActiveEmployee = (event) => {  
    this._commonService.Autocomplete('Common/GetActiveEmployee', event.query).subscribe(result => {
      this.delegateList = this.filterDataList(event.query, result);
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    });
  }

  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  SetEmployeeDetails(event) {    
    this.DelegateCreationForm.patchValue({
      EmployeeName:event.EmployeeName,
      EmployeeGPN:event.EmployeeGPN
    });
  
}

  SaveDelegate() {
    if (!this.DelegateCreationForm.valid) {
      alert('Please fill mandatory fields.');
      return false;
    }   

    if (this.delegateID != null) {    
        this.DelegateCreationForm.controls.DelegateId.setValue(this.delegateID);
      
    }
   
    this._delegateService.AddDelegate(this.DelegateCreationForm.value).subscribe(data => {
      if (data.IsSuccess) {      
          this._alertService.notify('success', 'Success!', data.Message);
          this._router.navigate(['home/view-delegate']);
      
      } else {
        this._alertService.notify('error', 'error!', data.Message);
      }
    }, (error) => {debugger
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  GetFormControls(controlName) {
    return this.DelegateCreationForm.controls[controlName];
  }

  GetDelegateByID(DelegateID: string) {
    this.status.setHttpStatus(true);
    this._delegateService.GetDelegateByID(DelegateID).subscribe(data => {debugger
      this.DelegateCreationForm.patchValue(data);
      this.DelegateCreationForm.controls.IsActive.setValue(String(data.IsActive));
      this.delegateList = {
        EmployeeName: data.DelegateName,       
        IsActive: data.IsActive,
        EmployeeGPN: data.UserGPN
      };
     this.DelegateCreationForm.controls.EmployeeName.setValue(data.DelegateName);
     this.DelegateCreationForm.controls.DelegateName.setValue(this.delegateList);
     this.DelegateCreationForm.controls.EmployeeGPN.setValue(data.UserGPN);
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
    () => { this.status.setHttpStatus(false); });
  }
  }




